<template>
  <div id="home">
    <maps @clicked="setInterval" class="maps">
      <template slot="title-rows">
        <b-row class="title-rows">
          <b-col>
            <h3 id="explore-title">Explore the Partnerships</h3>
          </b-col>
        </b-row>
        <b-row class="title-rows">
          <b-col>
            <h5 id="select-title">Select a state or province to start.</h5>
          </b-col>
        </b-row>
      </template>
    </maps>
    <div id="lower-search">
      <b-container>
        <b-row>
          <b-col>
            <h1>About Partnership 2020</h1>
            <p>
              <i>Partnership 2020: Leveraging US-India Cooperation in Higher Education to Harness Economic Opportunities and Innovation</i>
              is a collaborative agreement between University of Nebraska at Omaha (UNO) and US Department of State (DOS) with Center for Strategic
              and International Studies (CSIS) playing a key advisory role. This is a two-year project with most of the activities taking place in 2019 and 2020.
            </p>
            <p>
              If you have a partnership and do not see it on the site, you can submit a request at
              <a href="/request-listing" id="wrap">{{ baseUrl + 'request-listing' }}</a>
            </p>
          </b-col>
        </b-row>
        <br>
        <b-row>
          <b-col md="3">
            <b-form-group
              label="U.S. States"
              label-for="us-state">
              <b-form-select
                id="us-state"
                :options="usStateOptions"
                text-field="name"
                value-field="name"
                v-model="usState">
                  <template slot="first">
                    <option value="">All U.S. States</option>
                  </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="India States/Provinces"
              label-for="india-province">
              <b-form-select
                id="india-province"
                :options="indiaProvinceOptions"
                text-field="name"
                value-field="name"
                v-model="indiaProvince">
                <template slot="first">
                  <option value="">All India States/Provinces</option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="Sector"
              label-for="sector">
              <b-form-select
                id="sector"
                :options="sector_options"
                text-field="name"
                value-field="name"
                v-model="sector">
                <template slot="first">
                  <option value="">All Sectors</option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-col md="3">
            <b-form-group
              label="Type"
              label-for="type">
              <b-form-select
                id="type"
                :options="type_options"
                text-field="name"
                value-field="name"
                v-model="type">
                <template slot="first">
                  <option value="">All Types</option>
                </template>
              </b-form-select>
            </b-form-group>
          </b-col>
          <b-row id="submit-wrap" class="mr-auto ml-auto">
            <b-col md="12">
              <b-form-group
                label=""
                label-for="submit">
                <b-button
                  block
                  variant="primary"
                  @click="submitResults()">
                    Search
                </b-button>
              </b-form-group>
            </b-col>
          </b-row>
        </b-row>
      </b-container>
    </div>
  </div>
</template>

<script>
import Maps from '@/components/Maps'

export default {
  name: 'Home',
  components: {
    Maps
  },
  computed: {
    baseUrl () {
      return location.href
    },
    usStateOptions () {
      return this.$root.stateProvinceOptions.US
    },
    indiaProvinceOptions () {
      return this.$root.stateProvinceOptions.IN
    }
  },
  data: () => ({
    usState: '',
    indiaProvince: '',
    sector: '',
    type: '',
    sector_options: [],
    type_options: [],
    loading: false,
    interval: undefined
  }),
  methods: {
    setInterval (mapsInterval) {
      this.interval = mapsInterval
    },
    handleError (error) {
      return error
    },
    submitResults () {
      let queryString = ''
      queryString += ((this.order !== undefined) && (this.order !== '')) ? '&order=' + this.order : ''
      queryString += ((this.usState !== undefined) && (this.usState !== '')) ? '&us_state=' + this.usState : ''
      queryString += ((this.indiaProvince !== undefined) || (this.indiaProvince !== '')) ? '&india_province=' + this.indiaProvince : ''
      queryString += ((this.sector !== 'N/A') && (this.sector !== '')) ? '&sector=' + this.sector : ''
      queryString += ((this.type !== 'N/A') && (this.type !== '')) ? '&type=' + this.type : ''

      this.$router.push({
        path: '/partnerships?search=' + queryString
      })
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.axios({
        method: 'get',
        url: 'sectors'
      }).then(response => {
        vm.sector_options = response.data.sort()
      })

      vm.axios({
        method: 'get',
        url: 'types'
      }).then(response => {
        vm.type_options = response.data.sort()
      })
    })
  },
  beforeDestroy: function () {
    if (this.interval !== undefined) {
      this.interval.stop()
    }
  }
}
</script>

<style lang="scss" scoped>
  a {
    font-size: 1.05rem !important;
  }

  h2 {
    font-weight: bold;
  }

  #wrap {
    overflow-wrap: break-word;
  }

  #lower-search {
    padding-top: 2rem;
    margin-left: auto;
    margin-right: auto;
    width: 45rem;
  }

  @media screen and (max-width: 787px) {
    #lower-search {
      width: 100%;
    }
  }

  #submit-wrap {
    width: 100%;
  }

  @media screen and (max-width: 767px) {
    #maps { /* kill map if mobile */
      display: none;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/Home.vue